export const getInitialTheme = (): string => {
  if (typeof window !== "undefined" && window.localStorage) {
    const storedTheme = localStorage.getItem("theme")
    if (storedTheme) {
      return storedTheme
    }
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
}

export const setTheme = (theme: string) => {
  document.documentElement.setAttribute("data-theme", theme)
  localStorage.setItem("theme", theme)
}

export const toggleTheme = () => {
  const currentTheme = localStorage.getItem("theme") || getInitialTheme()
  const newTheme = currentTheme === "light" ? "dark" : "light"
  setTheme(newTheme)
}
